<div class="admin-selection-action" (click)="executeAction()">
  {{ label | translate}}

  <mat-icon>keyboard_arrow_right</mat-icon>
</div>
